var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "6" } }, [
                  _c("section", [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-code" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.$t("insert.order.invoiceNumber")) + ":"
                        )
                      ]),
                      _vm._v(" " + _vm._s(_vm.rowData.InvoiceNumber))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c("b-card", { staticClass: "summary-card" }, [
                      _c("div", { staticClass: "summary-area" }, [
                        _c("span", { staticClass: "summary-title" }, [
                          _vm._v(_vm._s(_vm.$t("insert.order.netTotal")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "summary-value text-muted" },
                          [_vm._v(": " + _vm._s(_vm.rowData.NetTotal))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("hr", { staticClass: "summary-hr" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "summary-title" }, [
                          _vm._v(_vm._s(_vm.$t("insert.order.vatTotal")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "summary-value text-muted" },
                          [_vm._v(": " + _vm._s(_vm.rowData.TotalVat))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("hr", { staticClass: "summary-hr" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "summary-title" }, [
                          _vm._v(_vm._s(_vm.$t("insert.order.grossTotal")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "summary-value text-muted" },
                          [_vm._v(": " + _vm._s(_vm.rowData.GrossTotal))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("hr", { staticClass: "summary-hr" })
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.order.enterInvoice"),
                      active: ""
                    }
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.InvoiceKind,
                                    "object",
                                    "insert.order.invoiceKind"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentDate,
                                    "date",
                                    "insert.order.documentDate"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentTime,
                                    "text",
                                    "insert.order.documentTime"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.ActualDeliveryDate,
                                    "date",
                                    "insert.order.actualDeliveryDate"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.ActualDeliveryTime,
                                    "text",
                                    "insert.order.actualDeliveryTime"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Customer,
                                    "object",
                                    "insert.order.customer"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.PriceList,
                                    "object",
                                    "insert.order.priceList"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentNumber,
                                    "text",
                                    "insert.order.documentNumber"
                                  )
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Description1,
                                    "text",
                                    "insert.order.description1"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.PrintedDispatchNumber,
                                    "text",
                                    "insert.order.printedDispatchNumber"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Representative,
                                    "object",
                                    "insert.order.representative"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DeliveryRepresentative,
                                    "object",
                                    "insert.order.deliveryRepresentative"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Route,
                                    "object",
                                    "insert.order.route"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Warehouse,
                                    "object",
                                    "insert.order.warehouse"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Vehicle,
                                    "object",
                                    "insert.order.vehicle"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.PaymentType,
                                    "object",
                                    "insert.order.paymentType"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  { attrs: { title: _vm.$t("insert.order.enterProducts") } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-4 asc__showPage-card" },
                              [
                                _c("NextExportDetail", {
                                  attrs: {
                                    url:
                                      "VisionNextInvoice/api/SalesReturnInvoice/ExcelExportItems",
                                    "record-id": _vm.rowData.RecordId,
                                    "record-key": "invoiceId",
                                    "file-name": _vm.$t(
                                      "insert.order.enterProducts"
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-table-simple",
                                  { attrs: { bordered: "", small: "" } },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.product")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.order.productCode"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.quantity")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.price")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.vatRate")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.netTotal")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.vatTotal")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.order.grossTotal"
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(_vm.rowData.InvoiceLines, function(
                                        o,
                                        i
                                      ) {
                                        return _c(
                                          "b-tr",
                                          { key: i },
                                          [
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.Item.Label))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.Item.Code))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.Quantity))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.Price))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.VatRate))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.NetTotal))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.TotalVat))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.GrossTotal))
                                            ])
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  { attrs: { title: _vm.$t("insert.order.paymentPlan") } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-4 asc__showPage-card" },
                              [
                                _c(
                                  "b-table-simple",
                                  { attrs: { bordered: "", small: "" } },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.order.paymentDate"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.PeriodDay")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.order.willPayAmount"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.order.paidAmount"
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(
                                        _vm.rowData.InvoicePaymentPlans,
                                        function(p, i) {
                                          return _c(
                                            "b-tr",
                                            { key: i },
                                            [
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.dateConvertFromTimezone(
                                                      p.PaymentDate
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(_vm._s(p.PaymentPeriod))
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(_vm._s(p.Amount))
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(_vm._s(p.Paid))
                                              ])
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fe633c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe633c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SalesReturnInvoice/get.vue
// module id = null
// module chunks = 